import React, { useState, useEffect, Key } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "@/components/message";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { IPurchaseRoFields, IDetailList, IPurchaseRoDetail, IPurchaseRoSearch, Detailed, IPurchaseRoSettleAndWhConfirm, IPurchaseDetails } from "../../purchaseRoType"
import { IMaterialBase, IMaterialDetail, IMaterialSearchFields, materialService } from "../../../../base/material/materialService"
import { purchaseRoService } from "../../purchaseRoService"
import { Switch } from "antd";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { useDictModel } from "../../../../base/dict/dictModel";
import { transPgToPagination, formatNum } from "@/utils/utils";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { convertRes2Blob } from "@/utils/exportFile";
import { useLockFn } from "ahooks";
interface Ro extends IDetailList {
    returnPrice?: string | number,
}
export type ISCMPoDescType = {
    numAll: number,
    itemNumAll: number,
    totalAll: number,
    [key: string]: any
}
export const usePurchaseRoDetailsModel = createModel(function () {
    const { supplieAllList, user, setLocale } = useGlobalModel()
    const { getTreeNodeName } = useDictModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)
    const [addModalVisible, setAddModalVisible] = useState<boolean>(false)  //新增商品弹框
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: IPurchaseDetails = {};
    const initDesc = {
        numAll: 0,  //数量
        itemNumAll: 0, //项数
        totalAll: 0 //总计
    }
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IPurchaseRoFields>({})
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([]);
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([]);
    const [addDesc, setAddDesc] = useState<ISCMPoDescType>(initDesc)

    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IPurchaseRoFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    const [lookDesc, setLookDesc] = useState<ISCMPoDescType>(initDesc)

    //详情数据
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([]);
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([]);
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([]);
    const [detailEditForm, setDetailEditForm] = useState<IPurchaseRoFields>({})
    const [editDesc, setEditDesc] = useState<ISCMPoDescType>(initDesc)


    //退货配件弹框配置
    const [workDataSource, setWorkDataSource] = useState<IPurchaseDetails[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IPurchaseDetails>({})
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<IPurchaseDetails[]>([]);

    useEffect(() => {
        let newDesc: ISCMPoDescType = { ...initDesc };
        detailDataSource.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.totalAll += Number(item.price) * Number(item.num);
        });
        newDesc.itemNumAll = detailDataSource.length
        setEditDesc(newDesc);
    }, [detailDataSource])

    useEffect(() => {
        let newDesc: ISCMPoDescType = { ...initDesc };
        detailAddList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.totalAll += Number(item.num) * Number(item.price);
        });
        newDesc.itemNumAll = detailAddList.length
        setAddDesc(newDesc);
    }, [detailAddList])

    useEffect(() => {
        let newDesc: ISCMPoDescType = { ...initDesc };
        detailLookList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.totalAll += Number(item.num) * Number(item.price);
        });
        newDesc.itemNumAll = detailLookList.length
        setLookDesc(newDesc);
    }, [detailLookList])

    //新增表单缓存
    const updateAddFormVal = (val: IPurchaseRoFields) => {
        let newVal = val
        if ("supplierCode" in val) {
            let { name, typeCode, typeName, contact, phone } = getFindItem(val.supplierCode as string, supplieAllList)
            newVal = { ...val, contact, phone, supplierName: name, supplierTypeCode: typeCode, supplierTypeName: typeName }
        }
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: IPurchaseRoFields) => {
        let newVal = val
        if ("supplierCode" in val) {
            let { name, typeCode, typeName, contact, phone } = getFindItem(val.supplierCode as string, supplieAllList)
            newVal = { ...val, contact, phone, supplierName: name, supplierTypeCode: typeCode, supplierTypeName: typeName }
        }
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    //根据id查询一条编辑或查看得数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await purchaseRoService.one(id);
        const { details, ...from } = retData
        if (retData && pattern == "edit") {
            setDetailDataSource(details as IDetailList[] ?? [])
            setDetailEditForm(from)
        } else if (retData && pattern == "look") {
            setDetailLookForm(from);
            setDetailLookList(details as IDetailList[] ?? [])
        }
    }
    //关闭弹框
    const resetWorkloadData = async (params: IPurchaseDetails) => {
        setSearchWorkData({ ...params });
        workloadData(initPgCfg, { ...params });
    }
    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: IPurchaseDetails = searchWorkData) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await purchaseRoService.purchaseDetails(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            return {
                ...item,
                returnNum: 0,
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
    }
    //筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: IPurchaseDetails[], detailList: IDetailList[]) => {
        console.log(modelList, detailList)
        const repetition: string[] = [];
        const newDetailData: Ro[] = []
        modelList.forEach(Item => {
            let isSelect = detailList.find(item => item.materialName == Item.materialName);
            if (isSelect === undefined) {
                newDetailData.push({
                    ...Item,
                    purchaseNum: Item.num,
                    purchasePrice: Item.price,
                    num: Item.returnNum,
                    detailsId: Item.id,
                    amount: formatNum(Number(Item.returnNum) * Number(Item.price)),
                    id: ""
                    // materialCode: Item.code,
                    // materialName: Item.name,
                    // price: Item.purchasePrice,
                    // returnNum: Item.purchaseNum,
                    // returnPrice: Item.purchasePrice,
                });
            } else {
                repetition.push(Item.materialName as string);
            }
        })
        return { newDetailData, repetition }
    }
    //添加到详情列表
    const transformsToRoDetailList = async (mode: string) => {
        //添加列表
        if (mode == "add") {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailAddList)
            setDetailAddList([...detailAddList, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });


        } else if (mode == "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailDataSource)
            setDetailDataSource([...detailDataSource, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        }
    }
    //删除详情列表数据
    const detailDetailList = async (mode: string) => {
        if (mode == "add") {
            const filterDetailList = detailAddList.filter(el => !!!detaiAddDataRowKeys.find(ele => ele == el.detailsId))
            setDetailAddList(filterDetailList)
            // globalPrompt("message", { text: `删除成功`, type: "success" });
            globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
            setDetaiAddDataRowKeys([]);
            setDetaiAddDataRow([]);
        } else if (mode == "edit") {
            const backendDetailList: any = detailDataRow.reduce((all, next) => {  //前端页面维护的需要删除的id
                if (next.id) {
                    all.push({ id: next.id });
                }
                return all;
            }, []);
            //删除详情列表调用的方法
            const deleteData = () => {
                const filterDetailList = detailDataSource.filter(el => !!!detailDataRowKeys.find(ele => ele === el.detailsId))
                setDetailDataSource(filterDetailList)
                // globalPrompt("message", { text: `删除成功`, type: "success" });
                globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
                setDetailDataRowKeys([]);
                setDetailDataRow([]);
            }
            if (backendDetailList.length > 0) {
                await purchaseRoService.materialDelete({ ids: backendDetailList }).then(res => {
                    if (res.retData) {
                        deleteData()
                    } else {
                        // globalPrompt("message", { text: `删除失败`, type: "success" });
                        globalPrompt("message", { text: Locale["Unsuccessfully deleted"], type: "success" });
                    }
                })
            } else {
                deleteData()
            }
        }
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: IPurchaseRoFields) => {
        if (detailAddList.length == 0) {
            // return globalPrompt("message", { text: `采退明细里还没有数据，快去添加吧`, type: "error" });
            return globalPrompt("message", { text: Locale["There is no data in the purchase return detail, please add it quickly."], type: "error" });
        }
        let newParams = {
            ...params,
            createUser: user.username,
            supplierName: getFindItem(params.supplierCode as string, supplieAllList).name,
            supplierTypeName: getTreeNodeName(params.supplierTypeCode as string),
            details: detailAddList
        }
        let { retData } = await purchaseRoService.insert(newParams);
        return retData;
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: IPurchaseRoFields) => {
        if (detailDataSource.length == 0) {
            // return globalPrompt("message", { text: `采退明细里还没有数据，快去添加吧`, type: "error" });
            return globalPrompt("message", { text: Locale["There is no data in the purchase return detail, please add it quickly."], type: "error" });

        }
        let newParams = {
            ...params,
            updateUser: user.username,
            supplierName: getFindItem(params.supplierCode as string, supplieAllList).name,
            supplierTypeName: getTreeNodeName(params.supplierTypeCode as string),
            details: detailDataSource
        }
        let { retData } = await purchaseRoService.update(newParams);
        return retData;
    })
    //结算操作
    const Settle = async (data: IPurchaseRoFields) => {
        const params = {
            reckoner: user.username,
            ...data
        }
        let { retData } = await purchaseRoService.settl(params);
        return retData

    }
    //出库操作
    const WhConfirm = async (data: IPurchaseRoFields) => {
        const params = {
            storekeeper: user.username,
            ...data
        }
        let { retData } = await purchaseRoService.delivery(params);
        return retData
    }
    //关闭页签清不同状态缓存
    // const resetCatch = async (type: string) => {
    //     console.log(type)
    //     if (type == "add") {
    //         setDetailAddList([]);
    //         setDetailAddForm({})
    //     } else if (type == "edit") {
    //         setDetailEditForm({});
    //         setDetailDataSource([]);
    //     }
    // }
    const resetAddCatch = async (type: string) => {
        setDetailAddList([]);
        setDetailAddForm({})
    }
    const resetEditCatch = async (type: string) => {
        setDetailEditForm({});
        setDetailDataSource([]);
    }
    //商品进销存明细
    const [materialHistoryModel, setMaterialHistoryModel] = useState<boolean>(false); //商品进销存明细弹框 
    const [materialHistoryRow, setMaterialHistoryRow] = useState<IDetailList>({}); //商品进销存明细弹框 
    const [materialHistoryType, setMaterialHistoryType] = useState<string>("trade-type.purchase")//trade-type.sale-order 查询历史状态
    return {
        addModalVisible,
        detailAddForm,
        detailAddList,
        detaiAddDataRowKeys,
        detaiAddDataRow,
        detailLookForm,
        detailLookList,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailEditForm,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        addDesc,
        editDesc,
        initPgCfg,
        lookDesc,
        setAddModalVisible,
        setDetailAddForm,
        setDetailAddList,
        setDetaiAddDataRowKeys,
        setDetaiAddDataRow,
        setDetailLookForm,
        setDetailLookList,
        setDetailDataSource,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailEditForm,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetWorkloadData,
        workloadData,
        modelScreenMethod,
        transformsToRoDetailList,
        detailDetailList,
        insertDetail,
        editDetail,
        Settle,
        WhConfirm,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        setAddDesc,
        setEditDesc,
        resetAddCatch,
        resetEditCatch,
        setLookDesc,
        materialHistoryModel,
        setMaterialHistoryModel,
        materialHistoryRow,
        setMaterialHistoryRow,
        materialHistoryType,
        setMaterialHistoryType,
    }
});